// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260929.1790689732/static/js/" + chunkId + "." + {"249":"e66f5b3a","463":"8a875d0b"}[chunkId] + ".chunk.js";
};